import { Location } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ParamInjectorServices } from 'src/app/services/ParamInjectorServices';

@Component({
    selector: 'orders-view',
    templateUrl: './orders-view.component.html',
    styleUrls: ['./orders-view.component.scss'],
    standalone: false
})
export class OrdersViewComponent implements OnInit {

  constructor(private routerParam:ActivatedRoute, private paramInjector:ParamInjectorServices) { 
    
  }

  @Input() codition:string = '0=0';
  @Input() nodata:boolean = true;
  ngOnInit(): void {

    this.paramInjector.injectParams(this);  
    
    if ( window.history.state ){
      
      const data:Object  = window.history.state;
      
      if ( Object.keys(data).findIndex(x=>x=='condition') > -1 ){
          this.codition = data['condition'];
          this.nodata = data['nodata'];
      }
      
    }

  }

}
